import { CheckAdmin } from './core/auth/check-admin.service';
import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules, CanActivate } from '@angular/router';
import { CheckHr } from './core/auth/check-hr.service';
import { CheckHrOrManager } from './core/auth/check-hr-or-manager.service';
import { CheckAdminOrHr } from './core/auth/check-admin-or-hr.service';
import { CheckLogged } from './core/auth/check-logged.service';
import { CheckJira } from './core/auth/check-jira.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'account',
    loadChildren: () => import('./pages/account/account.module').then(m => m.AccountModule),
    canActivate: [CheckLogged]
  },
  {
    path: 'support',
    loadChildren: () => import('./pages/support/support.module').then(m => m.SupportModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'app',
    loadChildren: () => import('./pages/tabs-page/tabs-page.module').then(m => m.TabsModule),
    canActivate: [CheckLogged]
  },
  {
    path: 'tutorial',
    loadChildren: () => import('./pages/tutorial/tutorial.module').then(m => m.TutorialModule),
    canActivate: [CheckLogged]
  },
  {
    path: 'configuration',
    loadChildren: () => import('./pages/configuration/configuration.module').then(m => m.ConfigurationModule),
    canActivate: [CheckAdminOrHr]
  },
  {
    path: 'eventi',
    loadChildren: () => import('./pages/eventi/eventi.module').then(m => m.EventiPageModule),
    canActivate: [CheckHrOrManager]
  },
  {
    path: 'analytics',
    loadChildren: () => import('./pages/configuration/analytics/analytics.module').then(m => m.AnalyticsPageModule),
    canActivate: [CheckAdminOrHr]
  },
  {
    path: 'user-detail',
    loadChildren: () => import('./pages/user-detail/user-detail.module').then(m => m.UserDetailPageModule)
  },
  {
    path: 'richieste-sede',
    loadChildren: () => import('./pages/richieste-sede/richieste-sede.module').then(m => m.RichiesteSedePageModule),
    canActivate: [CheckAdminOrHr]
  },
  {
    path: 'administrator',
    loadChildren: () => import('./pages/administrator/administrator.module').then(m => m.AdministratorPageModule),
    canActivate: [CheckAdminOrHr]
  },
  {
    path: 'feedback-dashboard',
    loadChildren: () => import('./pages/feedback-dashboard/feedback-dashboard.module').then(m => m.FeedbackDashboardPageModule),
    canActivate: [CheckAdmin]
  },
  {
    path: 'jira',
    loadChildren: () => import('./pages/jira/jira.module').then(m => m.JraPageModule),
    canActivate: [CheckJira]
  },
  {
    path: 'service-unavailable',
    loadChildren: () => import('./pages/service-unavailable/service-unavailable.module').then(m => m.ServiceUnavailableModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
